import { useContext } from 'react'

import { ConnectedAccountContext } from './ConnectedAccountContext'

export const useConnectedAccount = () => {
  const context = useContext(ConnectedAccountContext)
  if (context === undefined) {
    throw new Error('useConnectedAccount must be used within a ConnectedAccountProvider')
  }

  return context
}
